import { Block, Button } from '@mote/ui'
import styled from '@xstyled/styled-components'

export const Root = styled(Block)<{
  transparent?: boolean
  spacingTop?: boolean
}>(
  {
    boxSizing: 'border-box',
    position: 'relative',
    '& *': {
      fontFamily: 'sans !important'
    }
  },

  props =>
    !props.transparent && {
      padding: '16px',
      backgroundColor: props.theme.colors.grey.l4,
      borderRadius: '4px'
    },
  props =>
    props.spacingTop && {
      marginTop: '16px'
    }
)

export const IKnowWhatToDoButton = styled(Button)(props => ({
  backgroundColor: props.theme.colors.green.d1,
  '&:hover': {
    backgroundColor: props.theme.colors.green.d2
  }
}))

export const IMayNeedHelpButton = styled(Button)(props => ({
  backgroundColor: props.theme.colors.red.base,
  '&:hover': {
    backgroundColor: props.theme.colors.red.d1
  }
}))
